import React from 'react';
import { useFormContext } from 'react-hook-form';
import { AutocompleteField } from 'components/form';

import { VOFilters, VOFilterType } from '../../types';
import { useFilterOptions } from '../../../../list/api';

export const Location = () => {
  const { control } = useFormContext<VOFilters>();

  const { options, loading } = useFilterOptions(VOFilterType.LOCATION);

  const mappedOptions = options.map(option => ({
    label: [option.label, option?.meta?.locationCategory].filter(Boolean).join(' - '),
    value: option.value,
  }));

  return (
    <AutocompleteField
      multiple
      size="small"
      name="LOCATION"
      loading={loading}
      control={control}
      disableCloseOnSelect
      options={mappedOptions}
      disabled={!mappedOptions.length}
      textFieldProps={{
        size: 'small',
        label: 'Location',
        variant: 'outlined',
      }}
    />
  );
};
